import { Injectable } from '@angular/core';
import { IFAQs } from '../interfaces/ifaqs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs';
import authHeader from '../helpers/auth-header';

@Injectable({
     providedIn: 'root'
})
export class FaqsService {
     faqSet: IFAQs[] = [];
     userFilter: string[] = [];
     userFilter_FR: string[] = [];
     userFilter_ES: string[] = [];
     topicFilter: string[] = [];
     topicFilter_FR: string[] = [];
     topicFilter_ES: string[] = [];
     countUser: { [key: string]: string } = {};
     countUser_FR: { [key: string]: string } = {};
     countUser_ES: { [key: string]: string } = {};
     countTopic: { [key: string]: string } = {};
     countTopic_FR: { [key: string]: string } = {};
     countTopic_ES: { [key: string]: string } = {};
     constructor(private http: HttpClient) { }

     getFAQs() {
          const url = `${environment.APP_API_URL}/api/v1/Lists/FAQs`;
          return this.http.get(url)
               .pipe(
                    map((response: any) =>{
                         this.faqSet = (response as any);
                         this.baseFAQPageState();

                         return ['true']
                    }),
                    catchError((error : string) => {
                         console.error(error);
                         return ['false'];
                    })
               );
     }

     getFAQsForPreview(itemId: string, parentId: string) {
          const url = `${environment.APP_API_URL}/api/v1/Lists/FAQs/Preview?itemId={itemId}&parentId={parentId}`
               .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)))
               .replace(`{${"parentId"}}`, encodeURIComponent(String(parentId)));

          return this.http.get(url)
               .pipe(
                    map((response: any) =>{
                         this.faqSet = (response as any);
                         this.baseFAQPageState();
                         return ['true']
                    }),
                    catchError((error : string) => {
                         console.error(error);
                         return ['false'];
                    })
               );
     }

     baseFAQPageState() {
          //I would like the faq to have a index
          //incase we move to json files a some point. we we can have a line reference.
          //and we are going to build are filter Arrays
          let TopTenCount = 0;
          this.userFilter = [];
          this.userFilter_FR = [];
          this.userFilter_ES = [];
          this.topicFilter = [];
          this.topicFilter_FR = [];
          this.topicFilter_ES = [];

          this.faqSet = this.faqSet.map((element, index) => {
               element.featuredOrder = (element.featuredOrder === 0 ? 666 : element.featuredOrder);
               return element;
          });

          this.faqSet = this.faqSet.sort((a: any, b: any) => a.featuredOrder < b.featuredOrder ? -1 : a.featuredOrder > b.featuredOrder ? 1 : 0)
          for (let i: number = 0; i < this.faqSet.length; i++) {
               this.faqSet[i].index = i;
               if (this.faqSet[i].featuredOrder > 0 && TopTenCount < 10) {
                    TopTenCount++;
                    this.faqSet[i].displayed = true;
               } else {
                    this.faqSet[i].displayed = false;
               }

               // we seem to keep getting nulls in our tags. this should be fixed in admin at some point. 
               if (this.faqSet[i].tags === null || this.faqSet[i].stakeHolders === null) {
                    this.faqSet[i].index = this.faqSet[i].index * -1
               } else {

                    this.userFilter = this.userFilter.concat(this.faqSet[i].stakeHolders);
                    this.userFilter_FR = this.userFilter_FR.concat(this.faqSet[i].stakeHolders_FR);
                    this.userFilter_ES = this.userFilter_ES.concat(this.faqSet[i].stakeHolders_ES);

                    this.topicFilter = this.topicFilter.concat(this.faqSet[i].tags);
                    this.topicFilter_FR = this.topicFilter_FR.concat(this.faqSet[i].tags_FR);
                    this.topicFilter_ES = this.topicFilter_ES.concat(this.faqSet[i].tags_ES);

                    this.faqSet[i].answer = this.faqSet[i].answer.replace('~', environment.APP_PSP_BASE_URL);
               }
          }

          // Set EN filters
          this.countUser = this.userFilter.reduce(function (obj: any, b) {
               obj[b] = ++obj[b] || 1;
               return obj;
          }, {});

          this.countTopic = this.topicFilter.reduce(function (obj: any, b) {
               obj[b] = ++obj[b] || 1;
               return obj;
          }, {});

          this.userFilter = Object.keys(this.countUser);
          this.topicFilter = Object.keys(this.countTopic);

          // Set FR filters
          this.countUser_FR = this.userFilter_FR.reduce(function (obj: any, b) {
               obj[b] = ++obj[b] || 1;
               return obj;
          }, {});

          this.countTopic_FR = this.topicFilter_FR.reduce(function (obj: any, b) {
               obj[b] = ++obj[b] || 1;
               return obj;
          }, {});

          this.userFilter_FR = Object.keys(this.countUser_FR);
          this.topicFilter_FR = Object.keys(this.countTopic_FR);

          // Set ES filters
          this.countUser_ES = this.userFilter_ES.reduce(function (obj: any, b) {
               obj[b] = ++obj[b] || 1;
               return obj;
          }, {});

          this.countTopic_ES = this.topicFilter_ES.reduce(function (obj: any, b) {
               obj[b] = ++obj[b] || 1;
               return obj;
          }, {});

          this.userFilter_ES = Object.keys(this.countUser_ES);
          this.topicFilter_ES = Object.keys(this.countTopic_ES);
     }

     getTopTen(): IFAQs[] | any {
          const url = `${environment.APP_API_URL}/api/v1/Lists/FAQs`;
          const topTen: IFAQs[] = [];
          return this.http.get(url)
          .pipe(
               map((response: any) =>{
                    let allFaqs = (response as any);
                    for (let i: number = 0; i < allFaqs.length; i++) {
                         if (allFaqs[i].featuredOrder !== 0 && topTen.length < 10) {
                              const thisFaq: IFAQs = allFaqs[i];
                              thisFaq.displayed = true;
                              thisFaq.answer = thisFaq.answer.replace('~', environment.APP_PSP_BASE_URL);
                              thisFaq.index = topTen.length;
                              topTen.push(thisFaq);
                         }
                    }
                    return topTen;
               }),
               catchError((error : string) => {
                    console.error(error);
                    return false as any;
               })
          );
     }

}
